import { Routes } from '@angular/router';

import { setupFeatureFlagsForModule } from '@core/shared/util';

import { IndustriekatalogDetailComponent } from './detail/industriekatalog-detail.component';
import { IndustriekatalogeListComponent } from './list/industriekataloge-list.component';

const baseTitle = 'Katalogmanagement | Industriekatalog';

export const INDUSTRY_CATALOGS_ROUTES: Routes = [
  {
    path: '',
    component: IndustriekatalogeListComponent,
    title: `${baseTitle}e`,
    data: setupFeatureFlagsForModule({ customHeader: true }),
  },
  {
    path: ':id',
    component: IndustriekatalogDetailComponent,
    title: `${baseTitle}details`,
    data: setupFeatureFlagsForModule({ customHeader: true }),
  },
];
